import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import evidenceNotesService from "./evidence-notes-service";

export const caseEvidenceNoteSearchQuery = z.object({
	case_evidence_id: z.string(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const caseEvidenceNoteQueryOptions = (search?: z.infer<typeof caseEvidenceNoteSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_evidence_note", search],
		queryFn: () => evidenceNotesService.list(transformSearch(search, ["case_evidence_id"])),
		...options,
	});
};

export const useEvidenceNoteMutation = (caseEvidenceNoteId?: string) => {
	return useMutation({
		mutationKey: ["case_evidence_note", caseEvidenceNoteId],
		mutationFn: evidenceNotesService.upsertById,
		meta: {
			successMessage: "Note saved successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["case_evidence_note"] });
		},
	});
};

export const useEvidenceNoteDeleteMutation = (caseId: string) => {
	return useMutation({
		mutationKey: ["case_evidence_note", "delete"],
		mutationFn: evidenceNotesService.deleteById,
		meta: {
			successMessage: "Note archived successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["case_evidence_note"],
			});
		},
	});
};
